import { useUserService, useBrowserService } from './services'
import { TypeComponentCtaButton, TypeVariationContainerAuthAndDeviceTypeCta } from '../types'
import { isTypeComponentCtaButton } from '../types/content-types'

export type ctaArgType = TypeComponentCtaButton | TypeVariationContainerAuthAndDeviceTypeCta

export const useGetAuthAndDeviceTypeCta = () => {
  const { isAnonymous } = useUserService().currentUser
  const { isMobile } = useBrowserService()

  /**
   * @param { TypeComponentCtaButton | TypeVariationContainerAuthAndDeviceTypeCta} entry
   * Check for auth and device type cta variation container or cta.
   * If cta, return the cta
   * Else, check for user's authentication state and device type to return override. Default CTA is returned if there is no override.
   * @return {TypeComponentCtaButton}
   */
  const getAuthAndDeviceTypeCta = (entry: ctaArgType): TypeComponentCtaButton => {
    if (isTypeComponentCtaButton(entry)) {
      return entry
    }

    const {
      overrideForDesktopAnonymous,
      overrideForDesktopSignedIn,
      overrideForMobileAnonymous,
      overrideForMobileSignedIn,
      default: defaultCta,
    } = entry.fields

    if (overrideForDesktopAnonymous && isAnonymous && !isMobile) {
      return overrideForDesktopAnonymous
    }

    if (overrideForDesktopSignedIn && !isAnonymous && !isMobile) {
      return overrideForDesktopSignedIn
    }

    if (overrideForMobileAnonymous && isAnonymous && isMobile) {
      return overrideForMobileAnonymous
    }

    if (overrideForMobileSignedIn && !isAnonymous && isMobile) {
      return overrideForMobileSignedIn
    }

    return defaultCta
  }

  return { getAuthAndDeviceTypeCta }
}
